import { api_GET, api_POST, api_PUT, api_DELETE } from "../api/_axios.js";

const grupofde_api =
{
    getAll: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`grupofde`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getItem: function (id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`grupofde/${id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getPendentesProcessamento: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`grupofde/PendentesProcessamento`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    postGrupo: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`grupofde`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    putGrupo: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`grupofde`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    deleteGrupo: function (id) {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`grupofde`, id).then(result => {
                resolve(result)
            });
        });

        return promise;
    }
}

export default grupofde_api;
